import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

/**
 * HYNT website — Firebase project hynt-18 (separate from mobile app hynt-prod-app).
 * Marketing analytics: GTM (GTM-K7ZMJFK7) + REACT_APP_GA4_MEASUREMENT_ID in GTM GA4 tag.
 */
const measurementId = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();

const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyB6wDlGKeaYEKyTu1V9_UD1NQoQvFW-y70",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "hynt-18.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "hynt-18",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "hynt-18.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "790785570507",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID || "1:790785570507:web:428d18e82c025356a58d4e",
  ...(measurementId ? { measurementId } : {}),
};

const app = initializeApp(firebaseConfig);

export const analytics =
  typeof window !== "undefined" && measurementId ? getAnalytics(app) : null;

export { measurementId as webMeasurementId };
